<template>
  <div class="father">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>会员信息</el-breadcrumb-item>
        <el-breadcrumb-item>创建活动</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="" style="margin:5px">
      <div style="width:100%;height:auto;padding:0 10px 0 10px;">
        <div style="" class="card-title">
          <div style="display:inline-block;">
            <el-button type="success" @click="createNewActive" plain
              >新建优惠活动</el-button
            >
            <!-- <el-button type="primary" plain>发放会员卡</el-button> -->
          </div>
          <el-form
            v-show="false"
            :inline="true"
            class="demo-form-inline"
            style="display:inline-block;"
            @submit.native.prevent
          >
            <el-form-item label="活动名称">
              <el-input
                placeholder="输入活动名称搜索"
                v-model="search_input"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="search">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- :cell-style="{ padding: '7px' }" -->
        <!-- 会员卡表格 -->

        <el-table
          border
          :header-cell-style="{
            color: '#606266'
          }"
          max-height="580"
          ref="multipleTable"
          :data="activeData"
          tooltip-effect="dark"
          style="width: 100%;"
        >
          <el-table-column fixed align="center" type="index" width="55">
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            label="活动名称"
            prop="activity_base_info.activity_name"
            width="200"
          >
          </el-table-column>

          <el-table-column
            fixed
            align="center"
            prop="activity_id"
            label="活动id"
            width="240"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="activity_status"
            label="活动状态"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="period"
            label="活动时间"
            width="380"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="activity_base_info.activity_second_title"
            label="活动标题"
            width="300"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="" label="卷批次号" width="300">
            <template slot-scope="scope">
              <div
                v-for="(item, index) in scope.row.award_send_rule.full_send_rule
                  .award_list"
                :key="index"
              >
                {{ item.stock_id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="belong_merchant_id"
            label="归属商户"
            width="200"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="creator_merchant_id"
            label="创建服务商"
            width="200"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="award_send_rule.full_send_rule.transaction_amount_minimum"
            label="消费门槛"
            width="120"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="create_time"
            label="创建时间"
            width="200"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="update_time"
            label="更新时间"
            width="200"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="300"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="stopActive(scope.row)"
                >终止活动</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <createCard
      style="margin-top:8px"
      ref="createCardRef"
      v-show="true"
      @closeCreateCard="closeCreateCard"
    >
      <template v-slot:title>
        新建会员卡
      </template>
      <template v-slot:cardForm>
        <activeForm ref="activeFormRef"></activeForm>
      </template>
      <template v-slot:btn_name>
        <el-button
          type="primary"
          plain
          style="margin-left:204px"
          @click="createActive"
          >保存
        </el-button>
      </template>
    </createCard>
  </div>
</template>
<script>
import {
  GetCardClassify,
  getActivityList,
  testRes,
  mCouponDetail,
  terminationActive
} from "@/api/index";
import activeForm from "../../components/activeForm.vue";
import createCard from "@/components/createCard.vue";
export default {
  components: {
    createCard,
    activeForm
  },
  watch: {
    search_input: {
      handler(new_input, old_input) {
        this.search();
      }
    }
  },
  data() {
    return {
      search_input: "",
      // dialogFormVisible: false,
      height: "height:" + (document.body.clientHeight - 450) + "px",
      activeData: [
        {
          img_logo:
            "https://img.zcool.cn/community/01fd325cc9b5d5a801208f8ba67068.jpg@1280w_1l_2o_100sh.jpg",
          activity_name: "清仓甩卖",
          begin_time: "2022-12-01",
          end_time: "2022-12-31",
          img_activity: "",
          img_thumbnail: "",
          activity_title: "全部商品，清仓处理",
          mch_no: "1601011649",
          merchant_id: 1
        }
      ],
      allActive: []
      // multipleSelection: []
    };
  },
  async mounted() {
    const id = await mCouponDetail("1283560000000003");
    console.log("id:", id);

    console.log("获取活动：", await getActivityList());
    const res = await getActivityList();
    if (
      res.data.return_code == "SUCCESS" &&
      res.data.result_code == "SUCCESS"
    ) {
      this.allActive = this.activeData = JSON.parse(res.data.resp_data).data;
      for (let i = 0; i < this.allActive.length; i++) {
        this.activeData[i].period = (
          JSON.parse(res.data.resp_data).data[
            i
          ].activity_base_info.begin_time.substring(0, 19) +
          " 到 " +
          JSON.parse(res.data.resp_data).data[
            i
          ].activity_base_info.end_time.substring(0, 19)
        ).replace(/T/g, " ");
        switch (this.activeData[i].activity_status) {
          case "ACT_STATUS_UNKNOWN":
            this.activeData[i].activity_status = "状态未知";
            break;
          case "CREATE_ACT_STATUS":
            this.activeData[i].activity_status = "已创建";
            break;
          case "ONGOING_ACT_STATUS":
            this.activeData[i].activity_status = "运行中";
            break;
          case "TERMINATE_ACT_STATUS":
            this.activeData[i].activity_status = "已终止";
            break;
          case "STOP_ACT_STATUS":
            this.activeData[i].activity_status = "已暂停";
            break;
          case "OVER_TIME_ACT_STATUS":
            this.activeData[i].activity_status = "已过期";
            break;
          case "CREATE_ACT_FAILED":
            this.activeData[i].activity_status = "创建活动失败";
            break;
        }
      }
      /* console.log(
        this.activeData[0].award_send_rule.full_send_rule.award_list[0].stock_id
      ); */
    }
    /* this.allActivethis.activeData = await getActivityList();
    console.log(this.activeData) */
    return;
  },
  methods: {
    async stopActive(data) {
      // console.log(data);
      const res = await terminationActive(data.activity_id);
      console.log("停止", res);
    },
    text(index, row) {
      console.log(index, row);
    },
    createNewActive() {
      this.$refs.createCardRef.openBox();
    },
    createActive() {
      this.$refs.activeFormRef.createActive();
    },
    search() {
      return;
      let active_list = [];
      const arr = this.allActive;
      for (var x = 0; x < arr.length; x++) {
        if (arr[x].classify_name.indexOf(this.search_input) >= 0) {
          active_list.push(arr[x]);
        }
      }
      this.activeData = [];
      this.activeData = active_list;
    },
    closeCreateCard(res) {
      this.getActive();
    },
    async getActive() {
      return;
      var result = await GetCardClassify();
      testRes(result);
      const {
        data: { resp_data: res }
      } = result;
      this.activeData = res;
      this.allActive = res;
    }
  }
};
</script>

<style scoped>
.father {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 99%;
  background-color: #fff;
  margin: 0px;
  padding: 0px;
}
.el-breadcrumb {
  width: 50%;
  height: 25px;
  margin: 0px;
  padding: 5px 0 0 10px;
}
.card-title {
  height: 50px;
  display: flex;
  justify-content: space-between;
}
.dialog-footer {
  width: 100%;
  text-align: left;
  position: relative;
  left: 0px;
}
.switch-father {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>
